import { create, addDays, addMonths, now, compare } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { Lazy, compare as compare_2, uncurry, comparePrimitives, numberHash, int32ToString, equals } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { op_Addition, toString as toString_1, op_Subtraction, compare as compare_1, fromParts } from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import Decimal from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import { toString, Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { InvoiceEmailDTO, PayState_GetPayState_2E0C21E3, PaymentOptions$reflection, ReminderFeeDTO, ReminderFeeDTO$reflection, ReminderFee$reflection, InvoiceDueDateDTO, InvoiceDueDateDTO$reflection, InvoiceNoteDTO$reflection, PaymentApiDTO$reflection, Invoice$reflection, getAmount, UpcomingInvoice$reflection } from "./Model.js";
import { bool_type, tuple_type, int32_type, option_type, class_type, union_type, lambda_type, unit_type, record_type, string_type, list_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { loadEffect, LoadState_map, LoadState_defaultValue, GlobalDependencies$reflection, Flatpickr_OnChangeOption, LoadState$2, SaveStatus, getTranslationFrom, LoadState$2$reflection } from "../../Global.js";
import { ClaimStatusModule_toTranslation, PaymentStatusModule_toTranslation, Period, PeriodModule_ofString, TransactionTypeDescModule_fromInt, TransactionTypeDescModule_toTranslation, MonthModule_fromInt, MonthModule_toTranslation, IsoCountryCode$reflection } from "../../DomainTypes.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useDispatch, useSelector } from "../../Redux/Store.js";
import { empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import * as react from "react";
import { MaterialIcon_render_Z132847CC, IconProps, getMaterialIcon, Size, SveaIcon, renderSveaIconBySize, dotsLoading } from "../../ViewUtils.js";
import { parseInt64, DateOnlyExtensions_yyyy_MM_dd, logei, DateTimeOffsetExtensions_toDateHHmm, strToOpt, DateTimeExtensions_yyyy_MM_ddTHH_mm_ss_fffZ, DateTimeOffsetExtensions_toDate, DateTimeOffsetExtensions_toDateHHmmss, doubleToTwoDecimals, optToStr, DateTimeExtensions_toDate, Locale$reflection, Result_toBool, classNames, decimalToTwoDecimals, stackClasses, stripHtmlTags } from "../../Utils.js";
import { head, tryFind as tryFind_1, append as append_1, filter, truncate, sortByDescending, empty, cons, fold, singleton as singleton_1, tryHead, isEmpty, sortBy, map, ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { year as year_2, month as month_1 } from "../../fable_modules/fable-library.3.7.20/DateOnly.js";
import { List_groupBy } from "../../fable_modules/fable-library.3.7.20/Seq2.js";
import { some, bind, value as value_10, map as map_1, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { EmailModule_value, EmailModule_createNonEmpty, Email$reflection } from "../../Validation/Invoicee.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_1 } from "../../Components/StatefulFormFields/Text.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { error, info } from "../../Components/Message/Message.js";
import { ButtonKind, wrappedButton, DropDownButtonProps, DropDownButtonProps_get_GetDefault, dropDownButton, defaultProps, ButtonProps, ButtonProps_get_getDefault } from "../../Components/Button/Button.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_2 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { renderAsModalThenSaveState } from "../../Components/Modals/SaveState/SaveState.js";
import { ModalSize } from "../../Components/Modal/Modal.js";
import { PageinationProps$1, Pagination } from "../../Components/Pagination/Pagination.js";
import { CustomContentAreaTableProps, renderCustomContentAreaTable, Elements_renderHeader, renderTable, renderCustomTable } from "../../Components/Table/Table.js";
import { UTC__toDateTimeOffset } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { DateOptions, DateOptions_get_getDefault, inputDate } from "../../Components/FormFields/FormFields.js";
import { Value as Value_2, EnableRanges, Locale, FormatDateBy, Id as Id_5 } from "../../fable_modules/Fable.React.Flatpickr.3.0.0/Flatpickr.fs.js";
import { SendSMSDTO$reflection } from "../SendSMS/Model.js";
import { separateByThousands, unEscape } from "../../Utilities/String.js";
import { parseAndReplaceTemplate } from "../../Utilities/Templating.js";
import { FSharpSet__Contains } from "../../fable_modules/fable-library.3.7.20/Set.js";
import { loadClientCampignCodes, sendInvoiceViaEmail, saveReminderFee as saveReminderFee_1, saveInvoiceDueDate, createNewPayment, loadInvoiceNotes, loadInvoiceTransactions } from "./Api.js";
import { SendSMSModalProps, renderSendSMSModal } from "../SendSMS/View.js";
import { CreditModalProps, renderCreditModal } from "./Credit.js";
import { Thunks_loadInvoiceeFeesThunk, CreateFeeDTOV2, createFeeV2 } from "../../Api/Fee.js";
import { removeDirectInvoice, Thunks_loadPendingDirectInvoicesThunk, createDirectInvoice as createDirectInvoice_1, createInvoiceNote, loadDirectInvoiceInfo } from "../../Api/DirectInvoice.js";
import { tryFind, ofList } from "../../fable_modules/fable-library.3.7.20/Map.js";
import { getAmountIncludingVat } from "../FeesTable/View.js";
import { ValidatedUrlModule_value, UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { op_UnaryNegation_Int32 } from "../../fable_modules/fable-library.3.7.20/Int32.js";
import { toString as toString_2 } from "../../fable_modules/fable-library.3.7.20/Long.js";
import { sendSms } from "../SendSMS/Api.js";
import { DirectInvoiceModalProps, renderDirectInvoiceModal, RemoveDirectInvoiceProps, renderRemoveDirectInvoiceModal } from "./DirectInvoice.js";
import "../../../src/Containers/Invoices/View.scss";


function isUnpaidAndPastDueDate(invoice) {
    let copyOfStruct;
    if ((compare(invoice.InvoiceDate, (copyOfStruct = now(), addMonths(copyOfStruct, -12))) > 0) && (!equals(invoice.AmountExclVat, fromParts(0, 0, 0, false, 1)))) {
        if (invoice.PaymentDate == null) {
            const matchValue_1 = invoice.DueDate;
            if (matchValue_1 == null) {
                return false;
            }
            else {
                const dueDate = matchValue_1;
                return compare(now(), dueDate) > 0;
            }
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}

class UpcomingInvoicesProps extends Record {
    constructor(UpcomingInvoices, CountryCode) {
        super();
        this.UpcomingInvoices = UpcomingInvoices;
        this.CountryCode = CountryCode;
    }
}

function UpcomingInvoicesProps$reflection() {
    return record_type("Containers.Invoices.View.UpcomingInvoicesProps", [], UpcomingInvoicesProps, () => [["UpcomingInvoices", LoadState$2$reflection(list_type(UpcomingInvoice$reflection()), string_type)], ["CountryCode", IsoCountryCode$reflection()]]);
}

const renderUpcomingInvoices = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const children_21 = toList(delay(() => {
        let children_11;
        return append(singleton((children_11 = [getTranslation("CustomerContract.Invoicee.Invoices.UpcomingInvoices")], react.createElement("h5", {
            className: "mb-0",
        }, ...children_11))), delay(() => {
            let children_15, props_18, children_17, children_19;
            const matchValue = props.UpcomingInvoices;
            let pattern_matching_result, msg, upcomingInvoices_1;
            if (matchValue.tag === 1) {
                pattern_matching_result = 0;
            }
            else if (matchValue.tag === 3) {
                pattern_matching_result = 1;
                msg = matchValue.fields[0];
            }
            else if (matchValue.tag === 2) {
                if (isEmpty(matchValue.fields[0])) {
                    pattern_matching_result = 2;
                }
                else {
                    pattern_matching_result = 3;
                    upcomingInvoices_1 = matchValue.fields[0];
                }
            }
            else {
                pattern_matching_result = 0;
            }
            switch (pattern_matching_result) {
                case 0: {
                    return singleton(react.createElement("div", {
                        className: "p-4",
                    }, dotsLoading));
                }
                case 1: {
                    return singleton((children_15 = [stripHtmlTags(msg.split(""))], react.createElement("div", {
                        className: "p-4",
                    }, ...children_15)));
                }
                case 2: {
                    return singleton((props_18 = [new HTMLAttr(65, stackClasses(ofArray(["pt-2", "pb-2", "pr-2"])))], (children_17 = [getTranslation("CustomerContract.Invoicee.Invoices.NoUpcomingInvoices") + "."], react.createElement("div", keyValueList(props_18, 1), ...children_17))));
                }
                case 3: {
                    return singleton((children_19 = map((tupledArg) => {
                        let children_6, children_8;
                        const children_10 = [(children_6 = [int32ToString(tupledArg[0])], react.createElement("h5", {
                            className: "pt-3",
                        }, ...children_6)), (children_8 = map((u) => {
                            let children_2;
                            const month = MonthModule_toTranslation(getTranslation, MonthModule_fromInt(month_1(u.NextInvoiceDate)));
                            const children_4 = [react.createElement("div", {}, month), (children_2 = [decimalToTwoDecimals(u.AmountInclVat)], react.createElement("div", {}, ...children_2))];
                            return react.createElement("div", {
                                className: "month-row",
                            }, ...children_4);
                        }, tupledArg[1]), react.createElement("div", {}, ...children_8))];
                        return react.createElement(react.Fragment, {}, ...children_10);
                    }, sortBy((tupledArg_1) => tupledArg_1[0], List_groupBy((u_1) => year_2(u_1.NextInvoiceDate), upcomingInvoices_1, {
                        Equals: (x, y) => (x === y),
                        GetHashCode: numberHash,
                    }), {
                        Compare: comparePrimitives,
                    })), react.createElement("div", {}, ...children_19)));
                }
            }
        }));
    }));
    return react.createElement("div", {
        className: "invoices__upcoming",
    }, ...children_21);
}, void 0, uncurry(2, void 0), void 0, "renderUpcomingInvoices", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Invoices\\View.fs", 77);

function getCellClasses(invoice) {
    const payedAmount = defaultArg(invoice.PayedAmount, fromParts(0, 0, 0, false, 1));
    const totalAmount = getAmount(invoice);
    let patternInput;
    const matchValue = invoice.PaymentStatus;
    let pattern_matching_result;
    if (matchValue != null) {
        if (matchValue.tag === 3) {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            patternInput = ["invoice-table__strikethrough", false];
            break;
        }
        case 1: {
            if (compare_1(payedAmount, totalAmount) >= 0) {
                patternInput = ["", false];
            }
            else {
                const matchValue_2 = invoice.ClaimStatus;
                let pattern_matching_result_1;
                if (matchValue_2 == null) {
                    pattern_matching_result_1 = 3;
                }
                else if (matchValue_2.tag === 5) {
                    pattern_matching_result_1 = 1;
                }
                else if (matchValue_2.tag === 6) {
                    pattern_matching_result_1 = 1;
                }
                else if (matchValue_2.tag === 1) {
                    pattern_matching_result_1 = 1;
                }
                else if (matchValue_2.tag === 4) {
                    pattern_matching_result_1 = 1;
                }
                else if (matchValue_2.tag === 3) {
                    pattern_matching_result_1 = 2;
                }
                else if (matchValue_2.tag === 2) {
                    pattern_matching_result_1 = 2;
                }
                else if (matchValue_2.tag === 0) {
                    pattern_matching_result_1 = 3;
                }
                else if (matchValue_2.tag === 8) {
                    pattern_matching_result_1 = 3;
                }
                else {
                    pattern_matching_result_1 = 0;
                }
                switch (pattern_matching_result_1) {
                    case 0: {
                        patternInput = ["invoice-table__red-row", false];
                        break;
                    }
                    case 1: {
                        patternInput = ["invoice-table__orange-row", false];
                        break;
                    }
                    case 2: {
                        patternInput = ["invoice-table__yellow-row", false];
                        break;
                    }
                    case 3: {
                        patternInput = (((invoice.OcrNumber == null) && (!invoice.IsCardPayment)) ? ["invoice-table__grey-text", true] : ["", false]);
                        break;
                    }
                }
            }
            break;
        }
    }
    return [classNames(ofArray([["invoice-table__cell", true], [patternInput[0], true]])), patternInput[1]];
}

class SendPdfViaEmailModalProps extends Record {
    constructor(EmailAddresses, EmailTemplate, CloseModalFn, SendPdfViaEmailFn) {
        super();
        this.EmailAddresses = EmailAddresses;
        this.EmailTemplate = EmailTemplate;
        this.CloseModalFn = CloseModalFn;
        this.SendPdfViaEmailFn = SendPdfViaEmailFn;
    }
}

function SendPdfViaEmailModalProps$reflection() {
    return record_type("Containers.Invoices.View.SendPdfViaEmailModalProps", [], SendPdfViaEmailModalProps, () => [["EmailAddresses", list_type(string_type)], ["EmailTemplate", string_type], ["CloseModalFn", lambda_type(unit_type, unit_type)], ["SendPdfViaEmailFn", lambda_type(Email$reflection(), lambda_type(string_type, lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]))))]]);
}

const renderSendPdfViaEmailModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord, LabelText, children_9, inputRecord_1, LabelText_1, children_5, props_8;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const sendInvoiceViaEmailSaveStatus = react.useState(new SaveStatus(0));
    const emailAddressState = react.useState(defaultArg(tryHead(props.EmailAddresses), ""));
    const emailSubjectState = react.useState(getTranslation("CustomerContract.Invoicee.Invoices.EmailSubject"));
    const emailMessageState = react.useState(props.EmailTemplate);
    const validatedEmail = EmailModule_createNonEmpty(getTranslation, emailAddressState[0]);
    const emailSuggestionsId = "email-suggestions";
    const resetModal = () => {
        sendInvoiceViaEmailSaveStatus[1](new SaveStatus(0));
        emailAddressState[1](defaultArg(tryHead(props.EmailAddresses), ""));
        emailMessageState[1](props.EmailTemplate);
        props.CloseModalFn();
    };
    let emailSuggestionsHtml;
    const children_2 = map((email) => react.createElement("option", {
        value: email,
    }), props.EmailAddresses);
    emailSuggestionsHtml = react.createElement("datalist", {
        id: emailSuggestionsId,
    }, ...children_2);
    let bodyHtml;
    const children_11 = [render_1()((inputRecord = TextProps$1_GetDefault(), (LabelText = getTranslation("Common.Email"), new TextProps$1(emailAddressState[0], inputRecord.Type, inputRecord.Classes, (e) => {
        emailAddressState[1](Browser_Types_Event__Event_get_Value(e));
    }, inputRecord.Disabled, LabelText, "send-pdf-modal-email-address-input", (str) => EmailModule_createNonEmpty(getTranslation, str), inputRecord.DynamicWidth, ofArray([new HTMLAttr(54, "off"), new HTMLAttr(108, emailSuggestionsId)]), inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name)))), emailSuggestionsHtml, (children_9 = [render_1()((inputRecord_1 = TextProps$1_GetDefault(), (LabelText_1 = getTranslation("Common.Subject"), new TextProps$1(emailSubjectState[0], inputRecord_1.Type, inputRecord_1.Classes, (e_1) => {
        emailSubjectState[1](Browser_Types_Event__Event_get_Value(e_1));
    }, inputRecord_1.Disabled, LabelText_1, "send-pdf-modal-email-subject-input", inputRecord_1.ValidationFn, inputRecord_1.DynamicWidth, singleton_1(new HTMLAttr(54, "off")), inputRecord_1.OnBlur, inputRecord_1.OnFocus, inputRecord_1.AutoComplete, inputRecord_1.Name)))), (children_5 = [getTranslation("Common.Message")], react.createElement("label", {
        htmlFor: "message",
    }, ...children_5)), (props_8 = [new HTMLAttr(99, "send-pdf-modal-message-input"), new HTMLAttr(123, "message"), new HTMLAttr(65, "send-pdf-modal__message"), new DOMAttr(9, (e_2) => {
        emailMessageState[1](Browser_Types_Event__Event_get_Value(e_2));
    }), new HTMLAttr(161, emailMessageState[0])], react.createElement("textarea", keyValueList(props_8, 1)))], react.createElement("div", {}, ...children_9)), info((getTranslation("CustomerContract.Invoicee.Invoices.SendInvoiceViaEmailInfo") + ".").split(""))];
    bodyHtml = react.createElement("div", {
        className: "container__send-pdf-modal p-2 pb-3",
    }, ...children_11);
    let cancelButtonProps;
    const inputRecord_2 = ButtonProps_get_getDefault();
    cancelButtonProps = (new ButtonProps(getTranslation("Common.Cancel"), inputRecord_2.Content, (_arg_1) => {
        resetModal();
        props.CloseModalFn();
    }, inputRecord_2.Disabled, inputRecord_2.Id, inputRecord_2.SaveStatus, inputRecord_2.HTMLProps, inputRecord_2.ExtraClasses, inputRecord_2.Icon));
    let acceptButtonProps;
    const inputRecord_3 = ButtonProps_get_getDefault();
    acceptButtonProps = (new ButtonProps(getTranslation("Common.Send"), inputRecord_3.Content, (_arg_3) => {
        let emailMessage, emailSubject;
        if (validatedEmail.tag === 1) {
        }
        else {
            startImmediate((emailMessage = (emailMessageState[0]), (emailSubject = (emailSubjectState[0]), (sendInvoiceViaEmailSaveStatus[1](new SaveStatus(1)), singleton_2.Delay(() => singleton_2.Bind(props.SendPdfViaEmailFn(validatedEmail.fields[0], emailSubject, emailMessage), (_arg) => {
                const result = _arg;
                if (result.tag === 0) {
                    sendInvoiceViaEmailSaveStatus[1](new SaveStatus(2));
                    return singleton_2.Zero();
                }
                else {
                    sendInvoiceViaEmailSaveStatus[1](new SaveStatus(3, result.fields[0]));
                    return singleton_2.Zero();
                }
            }))))));
        }
    }, !Result_toBool(validatedEmail), inputRecord_3.Id, inputRecord_3.SaveStatus, inputRecord_3.HTMLProps, inputRecord_3.ExtraClasses, inputRecord_3.Icon));
    return renderAsModalThenSaveState(true, new ModalSize(1), getTranslation("CustomerContract.Invoicee.Invoices.SendInvoiceViaEmail"), bodyHtml, cancelButtonProps, acceptButtonProps, getTranslation("Common.Confirm"), (_arg_4) => {
        resetModal();
    }, singleton_1([getTranslation("CustomerContract.Invoicee.Invoices.SendInvoiceViaEmail"), sendInvoiceViaEmailSaveStatus[0]]));
}, void 0, uncurry(2, void 0), void 0, "renderSendPdfViaEmailModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Invoices\\View.fs", 229);

class InvoiceTab extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["General", "Payments", "Notes"];
    }
}

function InvoiceTab$reflection() {
    return union_type("Containers.Invoices.View.InvoiceTab", [], InvoiceTab, () => [[], [], []]);
}

class TabContainerProps extends Record {
    constructor(Locale, Invoice, AccountNumber, AccountNumber2, BIC, IBAN, OCR, LoadPayments, LoadNotes) {
        super();
        this.Locale = Locale;
        this.Invoice = Invoice;
        this.AccountNumber = AccountNumber;
        this.AccountNumber2 = AccountNumber2;
        this.BIC = BIC;
        this.IBAN = IBAN;
        this.OCR = OCR;
        this.LoadPayments = LoadPayments;
        this.LoadNotes = LoadNotes;
    }
}

function TabContainerProps$reflection() {
    return record_type("Containers.Invoices.View.TabContainerProps", [], TabContainerProps, () => [["Locale", Locale$reflection()], ["Invoice", Invoice$reflection()], ["AccountNumber", string_type], ["AccountNumber2", option_type(string_type)], ["BIC", option_type(string_type)], ["IBAN", option_type(string_type)], ["OCR", string_type], ["LoadPayments", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(PaymentApiDTO$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(PaymentApiDTO$reflection())]], [["ErrorValue", string_type]]])]))], ["LoadNotes", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(InvoiceNoteDTO$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(InvoiceNoteDTO$reflection())]], [["ErrorValue", string_type]]])]))]]);
}

const renderInvoiceTabs = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_51, children_53, tab_1, matchValue_3, paymentsAndRestAmounts, list_1, formatDate, headers, children_27, children_29, children_31, children_33, children_35, rows, matchValue_4, headers_1, children_45, children_47, children_49, rows_2, referenceStr, arg, accountNumberStr, arg_1, renderRow, children_13;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const countryTranslationsLoadState = useSelector((state_1) => state_1.Model.CountryTranslations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const getCountryTranslation = (key_1) => getTranslationFrom(countryTranslationsLoadState, key_1);
    const activeTabState = react.useState(new InvoiceTab(0));
    const paymentsState = react.useState(new LoadState$2(0));
    const notesState = react.useState(new LoadState$2(0));
    const renderTab = (tab, header) => {
        const props_1 = [new HTMLAttr(65, classNames(ofArray([["container__subnav", true], ["container__subnav--active", equals(activeTabState[0], tab)]]))), new HTMLAttr(99, ("invoices-" + toString(tab).toLocaleLowerCase()) + "-tab"), new DOMAttr(40, (_arg) => {
            activeTabState[1](tab);
        })];
        return react.createElement("div", keyValueList(props_1, 1), header);
    };
    const children_55 = [(children_51 = [renderTab(new InvoiceTab(0), getTranslation("Common.Overview")), renderTab(new InvoiceTab(1), getTranslation("CustomerContract.Invoicee.Invoices.Payments")), renderTab(new InvoiceTab(2), getTranslation("CustomerContract.Invoicee.Invoices.Notes"))], react.createElement("div", {
        className: "tabs__container",
    }, ...children_51)), (children_53 = [(tab_1 = (activeTabState[0]), (tab_1.tag === 1) ? ((matchValue_3 = (paymentsState[0]), (matchValue_3.tag === 1) ? dotsLoading : ((matchValue_3.tag === 3) ? error(matchValue_3.fields[0].split("")) : ((matchValue_3.tag === 2) ? (isEmpty(matchValue_3.fields[0]) ? info(getTranslation("CustomerContract.Invoicee.Invoices.NoPayments").split("")) : ((paymentsAndRestAmounts = ((list_1 = sortBy((p) => p.Date, matchValue_3.fields[0], {
        Compare: compare_2,
    }), fold((tupledArg, curr) => {
        const newRemaining = op_Subtraction(tupledArg[1], new Decimal(defaultArg(curr.PaymentAmount, 0)));
        return [cons([curr, newRemaining], tupledArg[0]), newRemaining];
    }, [empty(), getAmount(props.Invoice)], list_1)))[0], (formatDate = ((date) => DateTimeExtensions_toDate(props.Locale.ILocale, date)), (headers = ofArray([(children_27 = [getTranslation("Common.Date")], react.createElement("th", {
        className: "head",
    }, ...children_27)), (children_29 = [getTranslation("CustomerContract.Invoicee.Invoices.AccountingDate")], react.createElement("th", {
        className: "head",
    }, ...children_29)), (children_31 = [getTranslation("CustomerContract.Invoicee.Invoices.PaidAmount")], react.createElement("th", {
        className: "head head--align-right",
    }, ...children_31)), (children_33 = [getTranslation("CustomerContract.Invoicee.Invoices.RemainingAmount")], react.createElement("th", {
        className: "head head--align-right",
    }, ...children_33)), (children_35 = [getTranslation("CustomerContract.Invoicee.Invoices.TransactionType")], react.createElement("th", {
        className: "head",
    }, ...children_35))]), (rows = map((tupledArg_1) => {
        let children_15, children_17, children_19, children_21, children_23;
        const payment = tupledArg_1[0];
        const children_25 = [(children_15 = [optToStr(map_1(formatDate, payment.Date))], react.createElement("td", {
            className: "cell",
        }, ...children_15)), (children_17 = [optToStr(map_1(formatDate, payment.BookedDate))], react.createElement("td", {
            className: "cell",
        }, ...children_17)), (children_19 = [optToStr(map_1(doubleToTwoDecimals, payment.PaymentAmount))], react.createElement("td", {
            className: "cell cell--align-right",
        }, ...children_19)), (children_21 = [decimalToTwoDecimals(tupledArg_1[1])], react.createElement("td", {
            className: "cell cell--align-right",
        }, ...children_21)), (children_23 = [optToStr(map_1((arg_4) => TransactionTypeDescModule_toTranslation(getTranslation, TransactionTypeDescModule_fromInt(arg_4)), payment.TransactionTypeCode))], react.createElement("td", {
            className: "cell",
        }, ...children_23))];
        return react.createElement("tr", {}, ...children_25);
    }, paymentsAndRestAmounts), Pagination()(new PageinationProps$1((rows_1) => renderCustomTable(headers, rows_1), rows, 8, 0)))))))) : ((paymentsState[1](new LoadState$2(1)), (startImmediate(singleton_2.Delay(() => singleton_2.Bind(props.LoadPayments(), (_arg_1) => {
        const result = _arg_1;
        if (result.tag === 1) {
            paymentsState[1](new LoadState$2(3, result.fields[0]));
            return singleton_2.Zero();
        }
        else {
            paymentsState[1](new LoadState$2(2, result.fields[0]));
            return singleton_2.Zero();
        }
    }))), getTranslation("Common.WaitingToLoad")))))))) : ((tab_1.tag === 2) ? ((matchValue_4 = (notesState[0]), (matchValue_4.tag === 1) ? dotsLoading : ((matchValue_4.tag === 3) ? error(matchValue_4.fields[0].split("")) : ((matchValue_4.tag === 2) ? (isEmpty(matchValue_4.fields[0]) ? info(getTranslation("CustomerContract.Invoicee.Invoices.NoNotes").split("")) : ((headers_1 = ofArray([(children_45 = [getTranslation("Common.Date")], react.createElement("th", {
        className: "head head--align-left",
    }, ...children_45)), (children_47 = [getTranslation("CustomerContract.Invoicee.Invoices.Note")], react.createElement("th", {
        className: "head head--align-left",
    }, ...children_47)), (children_49 = [getTranslation("Common.User")], react.createElement("th", {
        className: "head",
    }, ...children_49))]), (rows_2 = map((note) => {
        let children_39, children_41;
        const updatedDateTitle = optToStr(map_1((utc) => DateTimeOffsetExtensions_toDateHHmmss(props.Locale.ILocale, UTC__toDateTimeOffset(utc)), note.Updated));
        const dateStr = optToStr(map_1((utc_1) => DateTimeOffsetExtensions_toDate(props.Locale.ILocale, UTC__toDateTimeOffset(utc_1)), note.Updated));
        const children_43 = [react.createElement("td", {
            className: "cell cell--align-left",
            title: updatedDateTitle,
        }, dateStr), (children_39 = [optToStr(note.Note)], react.createElement("td", {
            className: "cell cell--align-left",
        }, ...children_39)), (children_41 = [optToStr(note.UserName)], react.createElement("td", {
            className: "cell",
        }, ...children_41))];
        return react.createElement("tr", {}, ...children_43);
    }, matchValue_4.fields[0]), Pagination()(new PageinationProps$1((rows_3) => renderCustomTable(headers_1, rows_3), rows_2, 8, 0)))))) : ((notesState[1](new LoadState$2(1)), (startImmediate(singleton_2.Delay(() => singleton_2.Bind(props.LoadNotes(), (_arg_5) => {
        const result_1 = _arg_5;
        if (result_1.tag === 1) {
            notesState[1](new LoadState$2(3, result_1.fields[0]));
            return singleton_2.Zero();
        }
        else {
            notesState[1](new LoadState$2(2, result_1.fields[0]));
            return singleton_2.Zero();
        }
    }))), getTranslation("Common.WaitingToLoad")))))))) : ((referenceStr = ((arg = getCountryTranslation("CustomerContract.Invoicee.Invoices.Reference"), toText(printf("%s: "))(arg))), (accountNumberStr = ((arg_1 = getCountryTranslation("CustomerContract.Invoicee.Invoices.AccountNumber"), toText(printf("%s: "))(arg_1))), (renderRow = ((label, value) => {
        const children_6 = [react.createElement("td", {
            className: "pr-2",
        }, label), react.createElement("td", {}, value)];
        return react.createElement("tr", {}, ...children_6);
    }), (children_13 = toList(delay(() => {
        let arg_2, children_11;
        let accountNumber2RowHtml;
        const matchValue = props.AccountNumber2;
        if (matchValue != null) {
            const accountNumber2 = matchValue;
            accountNumber2RowHtml = renderRow((arg_2 = getCountryTranslation("CustomerContract.Invoicee.Invoices.AccountNumber2"), toText(printf("%s: "))(arg_2)), accountNumber2);
        }
        else {
            accountNumber2RowHtml = react.createElement(react.Fragment, {});
        }
        let ibanRowHtml;
        const matchValue_1 = props.IBAN;
        ibanRowHtml = ((matchValue_1 != null) ? renderRow("IBAN: ", matchValue_1) : react.createElement(react.Fragment, {}));
        let bicRowHtml;
        const matchValue_2 = props.BIC;
        bicRowHtml = ((matchValue_2 != null) ? renderRow("BIC: ", matchValue_2) : react.createElement(react.Fragment, {}));
        return singleton((children_11 = [renderRow(referenceStr, props.OCR), renderRow(accountNumberStr, props.AccountNumber), accountNumber2RowHtml, ibanRowHtml, bicRowHtml], react.createElement("tbody", {}, ...children_11)));
    })), react.createElement("table", {
        className: "fit-content",
    }, ...children_13))))))))], react.createElement("div", {
        className: "tabs__content",
    }, ...children_53))];
    return react.createElement("div", {
        className: "invoices__tabs",
    }, ...children_55);
}, void 0, uncurry(2, void 0), void 0, "renderInvoiceTabs", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Invoices\\View.fs", 467);

class ChangeDueDateProps extends Record {
    constructor(Locale, InvoiceDate, DueDate, PaymentTermsNetDays, CloseModalFn, SaveFn, ReloadInvoicesFn) {
        super();
        this.Locale = Locale;
        this.InvoiceDate = InvoiceDate;
        this.DueDate = DueDate;
        this.PaymentTermsNetDays = (PaymentTermsNetDays | 0);
        this.CloseModalFn = CloseModalFn;
        this.SaveFn = SaveFn;
        this.ReloadInvoicesFn = ReloadInvoicesFn;
    }
}

function ChangeDueDateProps$reflection() {
    return record_type("Containers.Invoices.View.ChangeDueDateProps", [], ChangeDueDateProps, () => [["Locale", Locale$reflection()], ["InvoiceDate", class_type("System.DateTime")], ["DueDate", option_type(class_type("System.DateTime"))], ["PaymentTermsNetDays", int32_type], ["CloseModalFn", lambda_type(unit_type, unit_type)], ["SaveFn", lambda_type(InvoiceDueDateDTO$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [int32_type, string_type], FSharpResult$2, () => [[["ResultValue", int32_type]], [["ErrorValue", string_type]]])]))], ["ReloadInvoicesFn", lambda_type(unit_type, unit_type)]]);
}

const renderChangeDueDateModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const saveState = react.useState(new SaveStatus(0));
    const dueDateState = react.useState(props.DueDate);
    let maxSelectableDate;
    let copyOfStruct = addDays(props.InvoiceDate, props.PaymentTermsNetDays);
    maxSelectableDate = addDays(copyOfStruct, 28);
    let bodyHtml;
    const children = [inputDate((inputRecord = DateOptions_get_getDefault(), new DateOptions(toList(delay(() => append(singleton(Id_5("tabs-edit-invoice-due-date")), delay(() => append(singleton(FormatDateBy((date) => DateTimeExtensions_toDate(props.Locale.ILocale, date))), delay(() => append(singleton(Locale(props.Locale.FlatpickrLocale)), delay(() => append(singleton(Flatpickr_OnChangeOption((arg) => {
        dueDateState[1](arg);
    })), delay(() => append(singleton(EnableRanges(singleton_1([props.InvoiceDate, maxSelectableDate]))), delay(() => (((dueDateState[0]) != null) ? singleton(Value_2(value_10(dueDateState[0]))) : empty_1()))))))))))))), getTranslation("CustomerContract.Invoicee.Invoices.ExpirationDate"), true, inputRecord.Disabled, inputRecord.OnClearClick)))];
    bodyHtml = react.createElement("div", {
        className: "m2 fit-content",
    }, ...children);
    let cancelButtonProps;
    const inputRecord_1 = ButtonProps_get_getDefault();
    cancelButtonProps = (new ButtonProps(getTranslation("Common.Cancel"), inputRecord_1.Content, (_arg_1) => {
        props.CloseModalFn();
    }, inputRecord_1.Disabled, "change-due-date-cancel-btn", inputRecord_1.SaveStatus, inputRecord_1.HTMLProps, inputRecord_1.ExtraClasses, inputRecord_1.Icon));
    let acceptButtonsProps;
    const inputRecord_2 = ButtonProps_get_getDefault();
    const Disabled = (dueDateState[0]) == null;
    acceptButtonsProps = (new ButtonProps(getTranslation("Common.Change"), inputRecord_2.Content, (_arg_2) => {
        let dueDate;
        const matchValue = dueDateState[0];
        if (matchValue != null) {
            startImmediate((dueDate = matchValue, (saveState[1](new SaveStatus(1)), singleton_2.Delay(() => singleton_2.Bind(props.SaveFn(new InvoiceDueDateDTO(DateTimeExtensions_yyyy_MM_ddTHH_mm_ss_fffZ(dueDate))), (_arg) => {
                const result = _arg;
                if (result.tag === 1) {
                    saveState[1](new SaveStatus(3, result.fields[0]));
                    return singleton_2.Zero();
                }
                else {
                    saveState[1](new SaveStatus(2));
                    return singleton_2.Zero();
                }
            })))));
        }
    }, Disabled, "change-due-date-accept-btn", inputRecord_2.SaveStatus, inputRecord_2.HTMLProps, inputRecord_2.ExtraClasses, inputRecord_2.Icon));
    return renderAsModalThenSaveState(true, new ModalSize(0), getTranslation("CustomerContract.Invoicee.Invoices.ChangeDueDate"), bodyHtml, cancelButtonProps, acceptButtonsProps, getTranslation("Common.Confirm"), (_arg_3) => {
        saveState[1](new SaveStatus(0));
        props.ReloadInvoicesFn();
        props.CloseModalFn();
    }, singleton_1([getTranslation("CustomerContract.Invoicee.Invoices.ChangeDueDate"), saveState[0]]));
}, void 0, uncurry(2, void 0), void 0, "renderChangeDueDateModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Invoices\\View.fs", 551);

export class ReminderFeeModalProps extends Record {
    constructor(CloseModalFn, ReminderFee, SaveReminderFee) {
        super();
        this.CloseModalFn = CloseModalFn;
        this.ReminderFee = ReminderFee;
        this.SaveReminderFee = SaveReminderFee;
    }
}

export function ReminderFeeModalProps$reflection() {
    return record_type("Containers.Invoices.View.ReminderFeeModalProps", [], ReminderFeeModalProps, () => [["CloseModalFn", lambda_type(unit_type, unit_type)], ["ReminderFee", ReminderFee$reflection()], ["SaveReminderFee", lambda_type(ReminderFeeDTO$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]))]]);
}

export const renderReminderFeeEditModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_4, children, children_10, children_6, children_8, inputRecord, LabelText;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const reasonState = react.useState(props.ReminderFee.Reason);
    const saveState = react.useState(new SaveStatus(0));
    let header;
    const arg_2 = getTranslation("CustomerContract.Invoicee.Invoices.ReminderFee");
    header = toText(printf("%s %i"))(arg_2)(props.ReminderFee.ReminderInvoiceNr);
    let bodyHtml;
    let reminderFeeDescription;
    const arg_4 = getTranslation("CustomerContract.Invoicee.Invoices.ReminderFeeDescription");
    reminderFeeDescription = toText(printf("%s %i"))(arg_4)(props.ReminderFee.ReminderInvoiceNr);
    const children_12 = [(children_4 = [(children = [getTranslation("CustomerContract.Invoicee.Invoices.ReminderFeeDescriptionText") + ":"], react.createElement("span", {
        className: "font-weight-bold",
    }, ...children)), react.createElement("span", {
        className: "ml-2",
    }, reminderFeeDescription)], react.createElement("div", {}, ...children_4)), (children_10 = [(children_6 = [getTranslation("CustomerContract.Invoicee.Invoices.ReminderFeeAmount") + ":"], react.createElement("span", {
        className: "font-weight-bold",
    }, ...children_6)), (children_8 = [toString_1(props.ReminderFee.Fee)], react.createElement("span", {
        className: "ml-2",
    }, ...children_8))], react.createElement("div", {}, ...children_10)), render_1()((inputRecord = TextProps$1_GetDefault(), (LabelText = getTranslation("CustomerContract.Invoicee.Invoices.ReminderFeeNotToChargeReason"), new TextProps$1(optToStr(reasonState[0]), inputRecord.Type, inputRecord.Classes, (e) => {
        const arg_6 = strToOpt(Browser_Types_Event__Event_get_Value(e));
        reasonState[1](arg_6);
    }, inputRecord.Disabled, LabelText, "reason-not-charge-reminder-fee", inputRecord.ValidationFn, inputRecord.DynamicWidth, inputRecord.HTMLProps, inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name))))];
    bodyHtml = react.createElement("div", {
        className: "reminder-fee-modal",
    }, ...children_12);
    const cancelButtonProps = new ButtonProps(getTranslation("Common.Cancel"), defaultProps.Content, (_arg_4) => {
        props.CloseModalFn();
    }, defaultProps.Disabled, "reminder-modal-cancel-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
    const acceptButtonProps = new ButtonProps(getTranslation("CustomerContract.Invoicee.Invoices.ReminderFeeDoNotCharge"), defaultProps.Content, (_arg_5) => {
        saveState[1](new SaveStatus(1));
        startImmediate(singleton_2.Delay(() => singleton_2.Bind(props.SaveReminderFee(new ReminderFeeDTO(props.ReminderFee.InvoiceeNr, props.ReminderFee.ReminderInvoiceNr, optToStr(reasonState[0]))), (_arg_1) => {
            const result = _arg_1;
            const arg = (result.tag === 1) ? (new SaveStatus(3, result.fields[0])) : (new SaveStatus(2));
            saveState[1](arg);
            return singleton_2.Zero();
        })));
    }, defaultProps.Disabled, "reminder-modal-cancel-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
    let saveStateStr;
    const matchValue = saveState[0];
    switch (matchValue.tag) {
        case 3:
        case 1: {
            saveStateStr = (getTranslation("Common.Saving") + "...");
            break;
        }
        case 2: {
            saveStateStr = getTranslation("Common.Saved");
            break;
        }
        default: {
            saveStateStr = "...";
        }
    }
    return renderAsModalThenSaveState(true, new ModalSize(1), header, bodyHtml, cancelButtonProps, acceptButtonProps, getTranslation("Common.Close"), (_arg_6) => {
        props.CloseModalFn();
    }, singleton_1([saveStateStr, saveState[0]]));
}, void 0, uncurry(2, void 0), void 0, "renderReminderFeeEditModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Invoices\\View.fs", 652);

class ContentAreaProps extends Record {
    constructor(Invoice, ReminderFee, InvoiceeNr, EmailAddresses, TemplateReplacements, GlobalDependencies, SendPdfViaEmailFn, AvailablePhoneNumbers, LoadAvailablePhoneNumbers, SendInvoiceViaSMSFn, LoadInvoices, Locale, PaymentOptions, ReloadReminderFees, ReloadPendingDirectInvoices, ReloadInvoiceeFees) {
        super();
        this.Invoice = Invoice;
        this.ReminderFee = ReminderFee;
        this.InvoiceeNr = InvoiceeNr;
        this.EmailAddresses = EmailAddresses;
        this.TemplateReplacements = TemplateReplacements;
        this.GlobalDependencies = GlobalDependencies;
        this.SendPdfViaEmailFn = SendPdfViaEmailFn;
        this.AvailablePhoneNumbers = AvailablePhoneNumbers;
        this.LoadAvailablePhoneNumbers = LoadAvailablePhoneNumbers;
        this.SendInvoiceViaSMSFn = SendInvoiceViaSMSFn;
        this.LoadInvoices = LoadInvoices;
        this.Locale = Locale;
        this.PaymentOptions = PaymentOptions;
        this.ReloadReminderFees = ReloadReminderFees;
        this.ReloadPendingDirectInvoices = ReloadPendingDirectInvoices;
        this.ReloadInvoiceeFees = ReloadInvoiceeFees;
    }
}

function ContentAreaProps$reflection() {
    return record_type("Containers.Invoices.View.ContentAreaProps", [], ContentAreaProps, () => [["Invoice", Invoice$reflection()], ["ReminderFee", option_type(ReminderFee$reflection())], ["InvoiceeNr", class_type("System.Int64")], ["EmailAddresses", list_type(string_type)], ["TemplateReplacements", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])], ["GlobalDependencies", GlobalDependencies$reflection()], ["SendPdfViaEmailFn", lambda_type(Email$reflection(), lambda_type(string_type, lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]))))], ["AvailablePhoneNumbers", LoadState$2$reflection(list_type(tuple_type(string_type, string_type)), string_type)], ["LoadAvailablePhoneNumbers", lambda_type(unit_type, unit_type)], ["SendInvoiceViaSMSFn", lambda_type(SendSMSDTO$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]))], ["LoadInvoices", lambda_type(unit_type, unit_type)], ["Locale", Locale$reflection()], ["PaymentOptions", LoadState$2$reflection(option_type(PaymentOptions$reflection()), string_type)], ["ReloadReminderFees", lambda_type(unit_type, unit_type)], ["ReloadPendingDirectInvoices", lambda_type(unit_type, unit_type)], ["ReloadInvoiceeFees", lambda_type(unit_type, unit_type)]]);
}

const renderContentArea = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord_5, children_7, children_5;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const countryTranslationsLoadState = useSelector((state_1) => state_1.Model.CountryTranslations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const getCountryTranslation = (key_1) => getTranslationFrom(countryTranslationsLoadState, key_1);
    const sendInvoiceViaEmailModalOpenState = react.useState(false);
    const sendInvoiceViaSMSModalOpenState = react.useState(false);
    const creditModalOpenState = react.useState(false);
    const changeDueDateModalOpenState = react.useState(false);
    const reminderFeeModalOpenState = react.useState(void 0);
    const emailTemplate = (props.GlobalDependencies.ClientConfig.InvoiceSendEmailTemplate === "") ? getCountryTranslation("CustomerContract.Invoicee.Invoices.EmailTemplate") : props.GlobalDependencies.ClientConfig.InvoiceSendEmailTemplate;
    const smsTemplate = (props.GlobalDependencies.ClientConfig.InvoiceSendSMSTemplate === "") ? getCountryTranslation("CustomerContract.Invoicee.Invoices.SMSTemplate") : props.GlobalDependencies.ClientConfig.InvoiceSendSMSTemplate;
    const emailTemplateStr = new Lazy(() => unEscape(parseAndReplaceTemplate(0, "\u003c#", "#\u003e", props.TemplateReplacements, emailTemplate)));
    const smsTemplateStr = new Lazy(() => unEscape(parseAndReplaceTemplate(0, "\u003c#", "#\u003e", props.TemplateReplacements, smsTemplate)));
    let isWithDebtCollection;
    const matchValue_2 = props.Invoice.ClaimStatus;
    if (matchValue_2 != null) {
        const claimStatus = matchValue_2;
        switch (claimStatus.tag) {
            case 6:
            case 7: {
                isWithDebtCollection = true;
                break;
            }
            default: {
                isWithDebtCollection = false;
            }
        }
    }
    else {
        isWithDebtCollection = false;
    }
    const hasEditInvoicePrivilege = FSharpSet__Contains(props.GlobalDependencies.Privileges, "FenixWeb.ClientContract.EditInvoice");
    let showChangeDueDateButton;
    const matchValue_3 = [isWithDebtCollection, hasEditInvoicePrivilege, props.Invoice.PaymentStatus];
    let pattern_matching_result;
    if (matchValue_3[0]) {
        pattern_matching_result = 0;
    }
    else if (matchValue_3[1]) {
        if (matchValue_3[2] != null) {
            pattern_matching_result = 1;
        }
        else {
            pattern_matching_result = 2;
        }
    }
    else {
        pattern_matching_result = 2;
    }
    switch (pattern_matching_result) {
        case 0: {
            showChangeDueDateButton = false;
            break;
        }
        case 1: {
            const paymentStatus = matchValue_3[2];
            switch (paymentStatus.tag) {
                case 1:
                case 2:
                case 3:
                case 8:
                case 9:
                case 10:
                case 11: {
                    showChangeDueDateButton = false;
                    break;
                }
                default: {
                    showChangeDueDateButton = true;
                }
            }
            break;
        }
        case 2: {
            showChangeDueDateButton = false;
            break;
        }
    }
    let showCreditInvoiceActions;
    const matchValue_4 = [hasEditInvoicePrivilege, props.Invoice.PaymentStatus];
    let pattern_matching_result_1;
    if (matchValue_4[0]) {
        if (matchValue_4[1] != null) {
            pattern_matching_result_1 = 0;
        }
        else {
            pattern_matching_result_1 = 1;
        }
    }
    else {
        pattern_matching_result_1 = 1;
    }
    switch (pattern_matching_result_1) {
        case 0: {
            const paymentStatus_1 = matchValue_4[1];
            switch (paymentStatus_1.tag) {
                case 1:
                case 2:
                case 3:
                case 8:
                case 9:
                case 10:
                case 11: {
                    showCreditInvoiceActions = false;
                    break;
                }
                default: {
                    showCreditInvoiceActions = true;
                }
            }
            break;
        }
        case 1: {
            showCreditInvoiceActions = false;
            break;
        }
    }
    let dropdownButtonHtml;
    const buttons = toList(delay(() => {
        let inputRecord;
        return append(props.GlobalDependencies.ClientConfig.AllowSendSms ? singleton((inputRecord = ButtonProps_get_getDefault(), new ButtonProps(getTranslation("CustomerContract.Invoicee.Invoices.SendInvoiceViaSMSButton"), inputRecord.Content, (_arg) => {
            sendInvoiceViaSMSModalOpenState[1](true);
        }, inputRecord.Disabled, "send-invoice-via-sms-btn", inputRecord.SaveStatus, inputRecord.HTMLProps, inputRecord.ExtraClasses, inputRecord.Icon))) : empty_1(), delay(() => {
            let inputRecord_1;
            return append(singleton((inputRecord_1 = ButtonProps_get_getDefault(), new ButtonProps(getTranslation("CustomerContract.Invoicee.Invoices.SendInvoiceViaEmailButton"), inputRecord_1.Content, (_arg_1) => {
                sendInvoiceViaEmailModalOpenState[1](true);
            }, inputRecord_1.Disabled, "send-invoice-via-email-btn", inputRecord_1.SaveStatus, inputRecord_1.HTMLProps, inputRecord_1.ExtraClasses, inputRecord_1.Icon))), delay(() => {
                let inputRecord_2;
                return append(showChangeDueDateButton ? singleton((inputRecord_2 = ButtonProps_get_getDefault(), new ButtonProps(getTranslation("CustomerContract.Invoicee.Invoices.ChangeDueDate"), inputRecord_2.Content, (_arg_2) => {
                    changeDueDateModalOpenState[1](true);
                }, inputRecord_2.Disabled, "change-due-date-btn", inputRecord_2.SaveStatus, inputRecord_2.HTMLProps, inputRecord_2.ExtraClasses, inputRecord_2.Icon))) : empty_1(), delay(() => {
                    let inputRecord_3;
                    return append(showCreditInvoiceActions ? singleton((inputRecord_3 = ButtonProps_get_getDefault(), new ButtonProps(getTranslation("CustomerContract.Invoicee.Invoices.CreditButtonHeading"), inputRecord_3.Content, (_arg_3) => {
                        creditModalOpenState[1](true);
                    }, inputRecord_3.Disabled, "credit-invoice-btn", inputRecord_3.SaveStatus, inputRecord_3.HTMLProps, inputRecord_3.ExtraClasses, inputRecord_3.Icon))) : empty_1(), delay(() => {
                        let inputRecord_4, reminderFee;
                        const matchValue_5 = props.ReminderFee;
                        let pattern_matching_result_2, reminderFee_1;
                        if (matchValue_5 != null) {
                            if ((reminderFee = matchValue_5, (reminderFee.DeletedAt == null) && (reminderFee.ReminderIncludedInvoiceNr == null))) {
                                pattern_matching_result_2 = 0;
                                reminderFee_1 = matchValue_5;
                            }
                            else {
                                pattern_matching_result_2 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_2 = 1;
                        }
                        switch (pattern_matching_result_2) {
                            case 0: {
                                return singleton((inputRecord_4 = ButtonProps_get_getDefault(), new ButtonProps(getTranslation("CustomerContract.Invoicee.Invoices.NoReminderFee"), inputRecord_4.Content, (_arg_4) => {
                                    reminderFeeModalOpenState[1](reminderFee_1);
                                }, inputRecord_4.Disabled, "no-reminder-fee-btn", inputRecord_4.SaveStatus, inputRecord_4.HTMLProps, inputRecord_4.ExtraClasses, inputRecord_4.Icon)));
                            }
                            case 1: {
                                return empty_1();
                            }
                        }
                    }));
                }));
            }));
        }));
    }));
    dropdownButtonHtml = dropDownButton((inputRecord_5 = DropDownButtonProps_get_GetDefault(), new DropDownButtonProps("action-invoice-dropdown-btn", getTranslation("Common.MoreActions"), buttons)));
    const children_9 = [(children_7 = [renderInvoiceTabs(new TabContainerProps(props.Locale, props.Invoice, LoadState_defaultValue("", LoadState_map((arg) => defaultArg(bind((p) => p.BankgiroNr, arg), ""), props.PaymentOptions)), LoadState_defaultValue(void 0, LoadState_map((option_2) => bind((p_1) => p_1.PlusgiroNr, option_2), props.PaymentOptions)), LoadState_defaultValue(void 0, LoadState_map((option_3) => bind((p_2) => p_2.BIC, option_3), props.PaymentOptions)), LoadState_defaultValue(void 0, LoadState_map((option_4) => bind((p_3) => p_3.IBAN, option_4), props.PaymentOptions)), optToStr(props.Invoice.OcrNumber), () => loadInvoiceTransactions(props.GlobalDependencies.ClientNr, props.InvoiceeNr, props.Invoice.InvoiceNumber), () => loadInvoiceNotes(props.GlobalDependencies.ClientNr, props.Invoice.InvoiceNumber))), (children_5 = toList(delay(() => append(singleton(dropdownButtonHtml), delay(() => {
        let matchValue_6;
        return append((matchValue_6 = (sendInvoiceViaEmailModalOpenState[0]), matchValue_6 ? singleton(renderSendPdfViaEmailModal(new SendPdfViaEmailModalProps(props.EmailAddresses, emailTemplateStr.Value, () => {
            sendInvoiceViaEmailModalOpenState[1](false);
        }, props.SendPdfViaEmailFn))) : singleton(react.createElement(react.Fragment, {}))), delay(() => {
            let matchValue_7;
            return append((matchValue_7 = (sendInvoiceViaSMSModalOpenState[0]), matchValue_7 ? append((props.AvailablePhoneNumbers.tag === 0) ? ((props.LoadAvailablePhoneNumbers(), empty_1())) : ((empty_1())), delay(() => singleton(renderSendSMSModal(new SendSMSModalProps(props.AvailablePhoneNumbers, () => {
                sendInvoiceViaSMSModalOpenState[1](false);
            }, smsTemplateStr.Value, props.SendInvoiceViaSMSFn, getTranslation("CustomerContract.Invoicee.Invoices.SendInvoiceViaSMS")))))) : singleton(react.createElement(react.Fragment, {}))), delay(() => {
                let matchValue_9;
                return append((matchValue_9 = (creditModalOpenState[0]), matchValue_9 ? singleton(renderCreditModal(new CreditModalProps(() => {
                    creditModalOpenState[1](false);
                    props.ReloadInvoiceeFees();
                }, void 0, props.GlobalDependencies.ClientConfig.AccountNoCrediting, props.Invoice, props.GlobalDependencies.CountryCode, (dto) => createNewPayment(props.GlobalDependencies.ClientNr, props.InvoiceeNr, props.Invoice.InvoiceNumber, dto), (dto_1) => createFeeV2(props.GlobalDependencies.ClientNr, new CreateFeeDTOV2(props.InvoiceeNr, dto_1.ContractNr, dto_1.FeeTemplateNr, dto_1.StartDate, dto_1.Type, dto_1.AmountExclVat, dto_1.VatPercentage, dto_1.Description, dto_1.AccountNo, dto_1.MonthsInAdvance, dto_1.BoundMonths, dto_1.CancellationPeriodMonths, dto_1.EndDate, dto_1.Attributes, dto_1.Units)), () => loadDirectInvoiceInfo(props.GlobalDependencies.ClientNr, props.InvoiceeNr), (dto_3) => createInvoiceNote(props.GlobalDependencies.ClientNr, props.InvoiceeNr, props.Invoice.InvoiceNumber, dto_3), (directInvoice) => createDirectInvoice_1(props.GlobalDependencies.ClientNr, props.InvoiceeNr, directInvoice), props.ReloadPendingDirectInvoices))) : singleton(react.createElement(react.Fragment, {}))), delay(() => {
                    let matchValue_10;
                    return append((matchValue_10 = (changeDueDateModalOpenState[0]), matchValue_10 ? singleton(renderChangeDueDateModal(new ChangeDueDateProps(props.Locale, props.Invoice.InvoiceDate, props.Invoice.DueDate, props.GlobalDependencies.ClientConfig.PaymentTermsNetDays, () => {
                        changeDueDateModalOpenState[1](false);
                    }, (dto_4) => saveInvoiceDueDate(props.GlobalDependencies.ClientNr, props.InvoiceeNr, props.Invoice.InvoiceNumber, dto_4), props.LoadInvoices))) : singleton(react.createElement(react.Fragment, {}))), delay(() => {
                        const matchValue_11 = reminderFeeModalOpenState[0];
                        return (matchValue_11 != null) ? singleton(renderReminderFeeEditModal(new ReminderFeeModalProps(() => {
                            reminderFeeModalOpenState[1](void 0);
                        }, matchValue_11, (dto_5) => {
                            const a = saveReminderFee_1(props.GlobalDependencies.ClientNr, dto_5);
                            return singleton_2.Delay(() => singleton_2.Bind(a, (_arg_6) => singleton_2.Return((props.ReloadReminderFees(), _arg_6))));
                        }))) : singleton(react.createElement(react.Fragment, {}));
                    }));
                }));
            }));
        }));
    })))), react.createElement("div", {}, ...children_5))], react.createElement("div", {
        className: "content-area__container",
    }, ...children_7))];
    return react.createElement("div", {
        className: "invoice-table__content-area",
    }, ...children_9);
}, void 0, uncurry(2, void 0), void 0, "renderContentArea", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Invoices\\View.fs", 912);

export class InvoicesProps extends Record {
    constructor(GlobalDependencies, InvoiceeNr, NoNextInvoice, EmailAdresses, IsTelecom, ExposeMonths, Locale, DirectInvoiceEnabled, LoadReminderFees, LoadUpcomingInvoices, LoadPaymentOptions, AvailablePhoneNumbers, LoadAvailablePhoneNumbers, LoadInvoices) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.InvoiceeNr = InvoiceeNr;
        this.NoNextInvoice = NoNextInvoice;
        this.EmailAdresses = EmailAdresses;
        this.IsTelecom = IsTelecom;
        this.ExposeMonths = (ExposeMonths | 0);
        this.Locale = Locale;
        this.DirectInvoiceEnabled = DirectInvoiceEnabled;
        this.LoadReminderFees = LoadReminderFees;
        this.LoadUpcomingInvoices = LoadUpcomingInvoices;
        this.LoadPaymentOptions = LoadPaymentOptions;
        this.AvailablePhoneNumbers = AvailablePhoneNumbers;
        this.LoadAvailablePhoneNumbers = LoadAvailablePhoneNumbers;
        this.LoadInvoices = LoadInvoices;
    }
}

export function InvoicesProps$reflection() {
    return record_type("Containers.Invoices.View.InvoicesProps", [], InvoicesProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["InvoiceeNr", class_type("System.Int64")], ["NoNextInvoice", bool_type], ["EmailAdresses", list_type(string_type)], ["IsTelecom", bool_type], ["ExposeMonths", int32_type], ["Locale", Locale$reflection()], ["DirectInvoiceEnabled", bool_type], ["LoadReminderFees", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(ReminderFee$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(ReminderFee$reflection())]], [["ErrorValue", string_type]]])]))], ["LoadUpcomingInvoices", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(UpcomingInvoice$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(UpcomingInvoice$reflection())]], [["ErrorValue", string_type]]])]))], ["LoadPaymentOptions", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [option_type(PaymentOptions$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", option_type(PaymentOptions$reflection())]], [["ErrorValue", string_type]]])]))], ["AvailablePhoneNumbers", LoadState$2$reflection(list_type(tuple_type(string_type, string_type)), string_type)], ["LoadAvailablePhoneNumbers", lambda_type(unit_type, unit_type)], ["LoadInvoices", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Invoice$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(Invoice$reflection())]], [["ErrorValue", string_type]]])]))]]);
}

export const renderInvoices = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_39, children_41, arg_31, children_63, children_67;
    const reduxDispatch = useDispatch();
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const pendingDirectInvoices = useSelector((state_1) => state_1.DirectInvoice.PendingDirectInvoices);
    const invoiceeFeesLoadState = useSelector((state_2) => state_2.Invoicee.InvoiceeFees);
    const paymentOptionsState = react.useState(new LoadState$2(0));
    const upcomingInvoicesState = react.useState(new LoadState$2(0));
    const invoicesState = react.useState(new LoadState$2(0));
    const reminderFeesState = react.useState(new LoadState$2(0));
    const directInvoiceModalIsOpenState = react.useState(false);
    const createDirectInvoiceSaveState = react.useState(new SaveStatus(0));
    const loadInvoiceeFees = () => {
        reduxDispatch(Thunks_loadInvoiceeFeesThunk(props.GlobalDependencies.ClientNr, props.InvoiceeNr));
    };
    const loadPendingDirectInvoices = () => {
        reduxDispatch(Thunks_loadPendingDirectInvoicesThunk(props.GlobalDependencies.ClientNr, props.InvoiceeNr));
    };
    const loadInvoicesAndReminderFees = () => {
        invoicesState[1](new LoadState$2(1));
        reminderFeesState[1](new LoadState$2(1));
        startImmediate(singleton_2.Delay(() => singleton_2.Bind(props.LoadInvoices(), (_arg) => singleton_2.Bind(props.LoadReminderFees(), (_arg_1) => {
            const matchValue = [_arg, _arg_1];
            const copyOfStruct = matchValue[0];
            if (copyOfStruct.tag === 1) {
                const copyOfStruct_1 = matchValue[1];
                if (copyOfStruct_1.tag === 1) {
                    invoicesState[1](new LoadState$2(3, copyOfStruct.fields[0]));
                    reminderFeesState[1](new LoadState$2(3, copyOfStruct_1.fields[0]));
                    return singleton_2.Zero();
                }
                else {
                    invoicesState[1](new LoadState$2(3, copyOfStruct.fields[0]));
                    reminderFeesState[1](new LoadState$2(2, copyOfStruct_1.fields[0]));
                    return singleton_2.Zero();
                }
            }
            else {
                const copyOfStruct_2 = matchValue[1];
                if (copyOfStruct_2.tag === 1) {
                    const arg_3 = new LoadState$2(2, map((i_3) => [i_3, void 0], sortByDescending((i_2) => i_2.InvoiceDate, copyOfStruct.fields[0], {
                        Compare: compare,
                    })));
                    invoicesState[1](arg_3);
                    reminderFeesState[1](new LoadState$2(3, copyOfStruct_2.fields[0]));
                    return singleton_2.Zero();
                }
                else {
                    const mappedReminderFees = ofList(map((rf) => [rf.ReminderInvoiceNr, rf], copyOfStruct_2.fields[0]));
                    const arg_1 = new LoadState$2(2, map((i_1) => [i_1, tryFind(i_1.InvoiceNumber, mappedReminderFees)], sortByDescending((i) => i.InvoiceDate, copyOfStruct.fields[0], {
                        Compare: compare,
                    })));
                    invoicesState[1](arg_1);
                    return singleton_2.Zero();
                }
            }
        }))));
    };
    react.useEffect(() => {
        loadInvoicesAndReminderFees();
        loadEffect(props.LoadPaymentOptions, (arg_10) => {
            paymentOptionsState[1](arg_10);
        });
        loadEffect(props.LoadUpcomingInvoices, (arg_12) => {
            const arg_11 = LoadState_map((arg_9) => truncate(12, sortBy((i_5) => i_5.NextInvoiceDate, arg_9, {
                Compare: compare,
            })), arg_12);
            upcomingInvoicesState[1](arg_11);
        });
        loadPendingDirectInvoices();
        loadInvoiceeFees();
    }, []);
    let invoiceeFeesTableHtml;
    switch (invoiceeFeesLoadState.tag) {
        case 1: {
            invoiceeFeesTableHtml = dotsLoading;
            break;
        }
        case 3: {
            invoiceeFeesTableHtml = error(invoiceeFeesLoadState.fields[0].split(""));
            break;
        }
        case 2: {
            const invoiceeFees = invoiceeFeesLoadState.fields[0];
            let creditInvoiceFees;
            const _arg_5 = filter((fee) => {
                if ((!fee.NoNextInvoice) && (fee.BilledTo == null)) {
                    return fee.AccountNo === props.GlobalDependencies.ClientConfig.AccountNoCrediting;
                }
                else {
                    return false;
                }
            }, invoiceeFees);
            creditInvoiceFees = (isEmpty(_arg_5) ? filter((fee_1) => {
                if (((((((!fee_1.NoNextInvoice) && (fee_1.BilledTo == null)) && (compare_1(fee_1.AmountExclVat, fromParts(0, 0, 0, false, 0)) < 0)) && equals(PeriodModule_ofString(fee_1.Type), new Period(0))) && (fee_1.BoundMonths === 0)) && (!fee_1.FinalInvoiceSent)) && (fee_1.CancellationPeriodMonths === 0)) {
                    return fee_1.CancelledDate == null;
                }
                else {
                    return false;
                }
            }, invoiceeFees) : _arg_5);
            if (isEmpty(creditInvoiceFees)) {
                invoiceeFeesTableHtml = react.createElement(react.Fragment, {});
            }
            else {
                const children_2 = [renderTable(ofArray([getTranslation("Common.FeeText"), getTranslation("Containers.FeesTable.Created"), getTranslation("Common.AmountExclVat"), getTranslation("Common.AmountInclVat"), getTranslation("Common.AccountNo")]), map((fee_2) => {
                    const amountInclVatStr = getAmountIncludingVat(fee_2.VatPercentage, fee_2.AmountExclVat);
                    return ofArray([fee_2.Description, DateTimeOffsetExtensions_toDateHHmm(props.Locale.ILocale, UTC__toDateTimeOffset(fee_2.CreatedAt)), decimalToTwoDecimals(fee_2.AmountExclVat), amountInclVatStr, int32ToString(fee_2.AccountNo)]);
                }, creditInvoiceFees))];
                invoiceeFeesTableHtml = react.createElement("div", {
                    className: "fit-content",
                    id: "invoicee-credit-fees",
                }, ...children_2);
            }
            break;
        }
        default: {
            invoiceeFeesTableHtml = react.createElement(react.Fragment, {});
        }
    }
    const matchValue_2 = invoicesState[0];
    switch (matchValue_2.tag) {
        case 3: {
            return error(matchValue_2.fields[0].split(""));
        }
        case 1: {
            return dotsLoading;
        }
        case 2: {
            const invoicesAndReminderFees = matchValue_2.fields[0];
            const headers_1 = ofArray([Elements_renderHeader(getTranslation("CustomerContract.Invoicee.Invoices.InvoiceNr")), Elements_renderHeader(getTranslation("CustomerContract.Invoicee.Invoices.InvoiceDate")), Elements_renderHeader(getTranslation("CustomerContract.Invoicee.Invoices.ExpirationDate")), Elements_renderHeader(getTranslation("CustomerContract.Invoicee.Invoices.PaymentDate")), (children_39 = [getTranslation("CustomerContract.Invoicee.Invoices.InvoiceAmount")], react.createElement("th", {
                className: "head text-right",
            }, ...children_39)), (children_41 = [getTranslation("CustomerContract.Invoicee.Invoices.RemainingAmount")], react.createElement("th", {
                className: "head text-right",
            }, ...children_41)), Elements_renderHeader(getTranslation("CustomerContract.Invoicee.Invoices.PaymentStatus")), Elements_renderHeader(getTranslation("CustomerContract.Invoicee.Invoices.DemandStatus")), Elements_renderHeader("")]);
            const rows_1 = map((_arg_6) => {
                let amount_1, vat, amount, matchValue_4, matchValue_5, copyOfStruct_3, matchValue_6, arg_28, arg_27, arg_26, arg_25, arg_24, arg_22, arg_21, arg_20, props_16, children_15, children_19, children_21, children_23, children_25, props_28, props_30, children_31, children_33, children_37;
                const reminderFeeOpt = _arg_6[1];
                const invoice = _arg_6[0];
                const getDate = (dateOpt) => {
                    if (dateOpt != null) {
                        return DateTimeExtensions_toDate(props.Locale.ILocale, dateOpt);
                    }
                    else {
                        return "";
                    }
                };
                const invoiceExistsInS1 = (invoice.OcrNumber != null) ? true : (compare(invoice.InvoiceDate, create(2022, 1, 1)) < 0);
                let amount_2;
                const matchValue_3 = [invoice.AmountExclVat, invoice.Vat];
                amount_2 = ((matchValue_3[0] != null) ? ((matchValue_3[1] != null) ? ((amount_1 = matchValue_3[0], (vat = matchValue_3[1], separateByThousands(decimalToTwoDecimals(op_Addition(amount_1, vat)))))) : ((amount = matchValue_3[0], separateByThousands(decimalToTwoDecimals(amount))))) : "");
                const invoiceDownloadIsVisible = invoiceExistsInS1 ? true : invoice.IsCardPayment;
                let invoiceDownloadLinkHtml;
                const props_5 = [new HTMLAttr(94, invoice.IsCardPayment ? ((matchValue_4 = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/SYSTEM/template/%i/invoice/%i/kvitto"))(props.GlobalDependencies.ClientNr)(invoice.InvoiceNumber))), (matchValue_4.tag === 1) ? ((logei(["Cant create invoiceDownloadLink. Error msg: ", matchValue_4.fields[0]]), "")) : ValidatedUrlModule_value(matchValue_4.fields[0]))) : ((matchValue_5 = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/invoice/%i/%i/%i"))(props.GlobalDependencies.ClientNr)(props.InvoiceeNr)(invoice.InvoiceNumber))), (matchValue_5.tag === 1) ? ((logei(["Cant create invoiceDownloadLink. Error msg: ", matchValue_5.fields[0]]), "")) : ValidatedUrlModule_value(matchValue_5.fields[0])))), new HTMLAttr(157, "_blank"), new HTMLAttr(65, classNames(ofArray([["invoice-table__download d-flex align-items-center justify-content-center", true], ["invisible", !invoiceDownloadIsVisible]]))), new HTMLAttr(158, getTranslation("CustomerContract.Invoicee.Invoices.DownloadInvoice"))];
                const children_4 = [renderSveaIconBySize(new SveaIcon(10), new Size(1))];
                invoiceDownloadLinkHtml = react.createElement("a", keyValueList(props_5, 1), ...children_4);
                const payState = PayState_GetPayState_2E0C21E3(invoice);
                const remainingAmountStr = (payState.tag === 1) ? separateByThousands(decimalToTwoDecimals(payState.fields[0])) : "";
                const trafficDownloadIsVisible = ((compare(invoice.InvoiceDate, (copyOfStruct_3 = now(), addMonths(copyOfStruct_3, op_UnaryNegation_Int32(props.ExposeMonths)))) > 0) && props.IsTelecom) && invoiceExistsInS1;
                let trafficDownloadLinkHtml;
                if (trafficDownloadIsVisible) {
                    const props_8 = [new HTMLAttr(94, (matchValue_6 = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Data/R35/TrafficInvoice/%i/%i/?format=slk"))(props.GlobalDependencies.ClientNr)(invoice.InvoiceNumber))), (matchValue_6.tag === 1) ? ((console.error(some("Cant create trafficDownloadLink. Error msg: "), matchValue_6.fields[0]), "")) : ValidatedUrlModule_value(matchValue_6.fields[0]))), new HTMLAttr(157, "_blank"), new HTMLAttr(65, "invoice-table__download d-flex align-items-center justify-content-center"), new HTMLAttr(158, getTranslation("CustomerContract.Invoicee.Invoices.DownloadTraffic"))];
                    const children_7 = [renderSveaIconBySize(new SveaIcon(9), new Size(3))];
                    trafficDownloadLinkHtml = react.createElement("a", keyValueList(props_8, 1), ...children_7);
                }
                else {
                    trafficDownloadLinkHtml = react.createElement(react.Fragment, {});
                }
                let reminderFeeIconHtml;
                if (reminderFeeOpt != null) {
                    const reminderFee = reminderFeeOpt;
                    const matchValue_7 = reminderFee.DeletedAt;
                    if (matchValue_7 != null) {
                        const props_13 = [new HTMLAttr(65, "cell__reminder-fee"), ["data-translation", "CustomerContract.Invoicee.Invoices.ReminderFeeIconRemoved"], new HTMLAttr(158, (arg_28 = DateOnlyExtensions_yyyy_MM_dd(matchValue_7), (arg_27 = getTranslation("CustomerContract.Invoicee.Invoices.ReminderFeeIconRemoved"), toText(printf("%s (%s)"))(arg_27)(arg_28))))];
                        const children_12 = [getMaterialIcon("notifications_off")];
                        reminderFeeIconHtml = react.createElement("div", keyValueList(props_13, 1), ...children_12);
                    }
                    else {
                        let patternInput;
                        const matchValue_8 = reminderFee.ReminderIncludedInvoiceNr;
                        if (matchValue_8 == null) {
                            patternInput = [(arg_26 = getTranslation("CustomerContract.Invoicee.Invoices.ReminderFeeIcon3"), (arg_25 = decimalToTwoDecimals(reminderFee.Fee), (arg_24 = getTranslation("CustomerContract.Invoicee.Invoices.ReminderFeeIcon"), toText(printf("%s %s, %s."))(arg_24)(arg_25)(arg_26)))), getMaterialIcon("edit_notifications")];
                        }
                        else {
                            const futureInvoiceNr = matchValue_8;
                            patternInput = [(arg_22 = getTranslation("CustomerContract.Invoicee.Invoices.ReminderFeeIcon2"), (arg_21 = decimalToTwoDecimals(reminderFee.Fee), (arg_20 = getTranslation("CustomerContract.Invoicee.Invoices.ReminderFeeIcon"), toText(printf("%s %s, %s %i."))(arg_20)(arg_21)(arg_22)(futureInvoiceNr)))), getMaterialIcon("notifications")];
                        }
                        reminderFeeIconHtml = react.createElement("div", {
                            className: "cell__reminder-fee",
                            ["data-translation"]: "CustomerContract.Invoicee.Invoices.ReminderFeeIcon",
                            title: patternInput[0],
                        }, patternInput[1]);
                    }
                }
                else {
                    reminderFeeIconHtml = react.createElement(react.Fragment, {});
                }
                const patternInput_1 = getCellClasses(invoice);
                const cellClasses = patternInput_1[0];
                let processingRowBadgeHtml;
                const matchValue_9 = (patternInput_1[1] && (!invoiceDownloadIsVisible)) && (!trafficDownloadIsVisible);
                if (matchValue_9) {
                    const children_17 = [(props_16 = [new HTMLAttr(65, stackClasses(ofArray(["badge", "badge-secondary"])))], (children_15 = [getTranslation("CustomerContract.Invoicee.Invoices.Processing")], react.createElement("div", keyValueList(props_16, 1), ...children_15)))];
                    processingRowBadgeHtml = react.createElement("div", {
                        className: "invoice-table__processing",
                    }, ...children_17);
                }
                else {
                    processingRowBadgeHtml = react.createElement(react.Fragment, {});
                }
                return [ofArray([(children_19 = [toString_2(invoice.InvoiceNumber)], react.createElement("td", {
                    className: cellClasses,
                }, ...children_19)), (children_21 = [DateTimeExtensions_toDate(props.Locale.ILocale, invoice.InvoiceDate)], react.createElement("td", {
                    className: cellClasses,
                }, ...children_21)), (children_23 = [getDate(invoice.DueDate)], react.createElement("td", {
                    className: cellClasses,
                }, ...children_23)), (children_25 = [getDate(invoice.PaymentDate)], react.createElement("td", {
                    className: cellClasses,
                }, ...children_25)), (props_28 = [new HTMLAttr(65, cellClasses + " invoice-table__cell--right-align")], react.createElement("td", keyValueList(props_28, 1), amount_2)), (props_30 = [new HTMLAttr(65, cellClasses + " invoice-table__cell--right-align")], react.createElement("td", keyValueList(props_30, 1), remainingAmountStr)), (children_31 = [defaultArg(map_1((_arg_7) => PaymentStatusModule_toTranslation(getTranslation, _arg_7), invoice.PaymentStatus), "")], react.createElement("td", {
                    className: cellClasses,
                }, ...children_31)), (children_33 = [defaultArg(map_1((_arg_8) => ClaimStatusModule_toTranslation(getTranslation, _arg_8), invoice.ClaimStatus), "")], react.createElement("td", {
                    className: cellClasses,
                }, ...children_33)), (children_37 = [react.createElement("div", {
                    className: "cell__aux",
                }, reminderFeeIconHtml, invoiceDownloadLinkHtml, trafficDownloadLinkHtml, processingRowBadgeHtml)], react.createElement("td", {
                    className: cellClasses,
                }, ...children_37))]), toString_2(invoice.InvoiceNumber)];
            }, invoicesAndReminderFees);
            const tableHtml = Pagination()(new PageinationProps$1((rows_2) => renderCustomContentAreaTable(new CustomContentAreaTableProps(headers_1, rows_2, (rowId) => map_1((tupledArg_2) => {
                const invoice_1 = tupledArg_2[0];
                let remainingAmountStr_1;
                const remainingAmount = op_Subtraction(op_Addition(defaultArg(invoice_1.AmountExclVat, fromParts(0, 0, 0, false, 1)), defaultArg(invoice_1.Vat, fromParts(0, 0, 0, false, 1))), defaultArg(invoice_1.PayedAmount, fromParts(0, 0, 0, false, 1)));
                remainingAmountStr_1 = decimalToTwoDecimals((compare_1(remainingAmount, fromParts(0, 0, 0, false, 1)) < 0) ? fromParts(0, 0, 0, false, 1) : remainingAmount);
                const dueDate = map_1((date_5) => DateTimeExtensions_toDate(props.Locale.ILocale, date_5), invoice_1.DueDate);
                let paymentRelatedReplacements;
                const matchValue_10 = paymentOptionsState[0];
                let pattern_matching_result, paymentOptions;
                if (matchValue_10.tag === 2) {
                    if (matchValue_10.fields[0] != null) {
                        pattern_matching_result = 0;
                        paymentOptions = matchValue_10.fields[0];
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
                switch (pattern_matching_result) {
                    case 0: {
                        paymentRelatedReplacements = ofArray([["bgnr_svea", optToStr(paymentOptions.BankgiroNr)], ["pgnr_svea", optToStr(paymentOptions.PlusgiroNr)], ["iban", optToStr(paymentOptions.IBAN)], ["swift", optToStr(paymentOptions.BIC)], ["bic", optToStr(paymentOptions.BIC)]]);
                        break;
                    }
                    case 1: {
                        paymentRelatedReplacements = empty();
                        break;
                    }
                }
                return renderContentArea(new ContentAreaProps(invoice_1, tupledArg_2[1], props.InvoiceeNr, props.EmailAdresses, ofList(append_1(toList(delay(() => append(singleton(["client_name", props.GlobalDependencies.ClientName]), delay(() => append(singleton(["reference", optToStr(invoice_1.OcrNumber)]), delay(() => append(singleton(["amount", remainingAmountStr_1]), delay(() => ((dueDate != null) ? singleton(["due_date", value_10(dueDate)]) : empty_1()))))))))), paymentRelatedReplacements)), props.GlobalDependencies, (email, emailSubject, emailMessage) => sendInvoiceViaEmail(props.GlobalDependencies.ClientNr, props.InvoiceeNr, invoice_1.InvoiceNumber, new InvoiceEmailDTO(emailSubject, emailMessage, EmailModule_value(email), props.GlobalDependencies.ClientConfig.EmailFromSender)), props.AvailablePhoneNumbers, props.LoadAvailablePhoneNumbers, (data) => sendSms(props.GlobalDependencies.ClientNr, props.InvoiceeNr, data), loadInvoicesAndReminderFees, props.Locale, paymentOptionsState[0], () => {
                    reminderFeesState[1](new LoadState$2(1));
                    startImmediate(singleton_2.Delay(() => singleton_2.Bind(props.LoadReminderFees(), (_arg_2) => {
                        const result = _arg_2;
                        if (result.tag === 0) {
                            const reminderFees_2 = result.fields[0];
                            const mappedReminderFees_1 = ofList(map((rf_1) => [rf_1.ReminderInvoiceNr, rf_1], reminderFees_2));
                            const matchValue_1 = invoicesState[0];
                            if (matchValue_1.tag === 2) {
                                const arg_6 = new LoadState$2(2, map((tupledArg) => {
                                    const i_4 = tupledArg[0];
                                    return [i_4, tryFind(i_4.InvoiceNumber, mappedReminderFees_1)];
                                }, matchValue_1.fields[0]));
                                invoicesState[1](arg_6);
                                return singleton_2.Zero();
                            }
                            else {
                                reminderFeesState[1](new LoadState$2(2, reminderFees_2));
                                return singleton_2.Zero();
                            }
                        }
                        else {
                            reminderFeesState[1](new LoadState$2(3, result.fields[0]));
                            return singleton_2.Zero();
                        }
                    })));
                }, loadPendingDirectInvoices, loadInvoiceeFees));
            }, tryFind_1((tupledArg_1) => equals(tupledArg_1[0].InvoiceNumber, parseInt64(rowId)), invoicesAndReminderFees)), void 0)), rows_1, 12, 0));
            let directInvoiceHtml;
            if (props.DirectInvoiceEnabled) {
                switch (pendingDirectInvoices.tag) {
                    case 1: {
                        directInvoiceHtml = dotsLoading;
                        break;
                    }
                    case 3: {
                        directInvoiceHtml = error(pendingDirectInvoices.fields[0].split(""));
                        break;
                    }
                    case 2: {
                        const pendingDirectInvoices_1 = pendingDirectInvoices.fields[0];
                        const pendingDirectInvoiceOpt = (!isEmpty(pendingDirectInvoices_1)) ? head(pendingDirectInvoices_1) : (void 0);
                        let directInvoiceButtonHtml;
                        const balloonText = unEscape(getTranslation("Billing.DirectInvoice.InfoText"));
                        const iconProps = new IconProps(react.createElement("div", {
                            className: "invoices__direct-invoice-info p-1",
                        }, balloonText), "help");
                        const props_50 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center"])))];
                        const children_49 = toList(delay(() => {
                            let matchValue_12, pendingDirectInvoice;
                            return append((matchValue_12 = pendingDirectInvoiceOpt, (matchValue_12 != null) ? ((pendingDirectInvoice = matchValue_12, singleton(wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("Billing.DirectInvoice.Remove"), defaultProps.Content, (_arg_16) => {
                                directInvoiceModalIsOpenState[1](true);
                            }, defaultProps.Disabled, "remove-direct-invoice-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))))) : singleton(wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("Billing.DirectInvoice"), defaultProps.Content, (_arg_15) => {
                                directInvoiceModalIsOpenState[1](true);
                            }, defaultProps.Disabled, "create-direct-invoice-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)))), delay(() => {
                                let children_47;
                                return singleton((children_47 = [MaterialIcon_render_Z132847CC(iconProps)], react.createElement("div", {
                                    className: "ml-2",
                                }, ...children_47)));
                            }));
                        }));
                        directInvoiceButtonHtml = react.createElement("div", keyValueList(props_50, 1), ...children_49);
                        let modalHtml;
                        const matchValue_13 = directInvoiceModalIsOpenState[0];
                        if (matchValue_13) {
                            if (pendingDirectInvoiceOpt != null) {
                                const pendingDirectInvoice_1 = pendingDirectInvoiceOpt;
                                modalHtml = renderRemoveDirectInvoiceModal(new RemoveDirectInvoiceProps(() => {
                                    directInvoiceModalIsOpenState[1](false);
                                }, () => {
                                    let a_3;
                                    startImmediate((a_3 = removeDirectInvoice(props.GlobalDependencies.ClientNr, props.InvoiceeNr, pendingDirectInvoice_1.InvoiceeBatchId), singleton_2.Delay(() => singleton_2.Bind(a_3, (_arg_20) => singleton_2.Return(loadPendingDirectInvoices())))));
                                }));
                            }
                            else {
                                modalHtml = renderDirectInvoiceModal(new DirectInvoiceModalProps(props.Locale, () => loadDirectInvoiceInfo(props.GlobalDependencies.ClientNr, props.InvoiceeNr), () => loadClientCampignCodes(props.GlobalDependencies.ClientNr), void 0, false, empty(), props.GlobalDependencies.ClientConfig.EnableTerminationProcess, (dto_2) => {
                                    let a_1;
                                    startImmediate((a_1 = ((createDirectInvoiceSaveState[1](new SaveStatus(1)), singleton_2.Delay(() => singleton_2.Bind(createDirectInvoice_1(props.GlobalDependencies.ClientNr, props.InvoiceeNr, dto_2), (_arg_4) => {
                                        const result_1 = _arg_4;
                                        const arg_8 = (result_1.tag === 1) ? (new SaveStatus(3, result_1.fields[0])) : (new SaveStatus(2));
                                        createDirectInvoiceSaveState[1](arg_8);
                                        return singleton_2.Return("");
                                    })))), singleton_2.Delay(() => singleton_2.Bind(a_1, (_arg_18) => singleton_2.Return(loadPendingDirectInvoices())))));
                                }, () => {
                                    directInvoiceModalIsOpenState[1](false);
                                }));
                            }
                        }
                        else {
                            modalHtml = react.createElement(react.Fragment, {});
                        }
                        let saveStateHtml;
                        const matchValue_14 = createDirectInvoiceSaveState[0];
                        switch (matchValue_14.tag) {
                            case 1: {
                                saveStateHtml = dotsLoading;
                                break;
                            }
                            case 3: {
                                saveStateHtml = error(matchValue_14.fields[0].split(""));
                                break;
                            }
                            case 2: {
                                saveStateHtml = react.createElement(react.Fragment, {});
                                break;
                            }
                            default: {
                                saveStateHtml = react.createElement(react.Fragment, {});
                            }
                        }
                        const children_54 = toList(delay(() => append((!props.NoNextInvoice) ? singleton(directInvoiceButtonHtml) : empty_1(), delay(() => append(singleton(modalHtml), delay(() => singleton(saveStateHtml)))))));
                        directInvoiceHtml = react.createElement("div", {
                            className: "invoices__create-direct-invoice",
                        }, ...children_54);
                        break;
                    }
                    default: {
                        directInvoiceHtml = react.createElement(react.Fragment, {});
                    }
                }
            }
            else {
                directInvoiceHtml = react.createElement(react.Fragment, {});
            }
            let warningMessageHtml;
            const matchValue_15 = reminderFeesState[0];
            if (matchValue_15.tag === 2) {
                const reminderFees_3 = matchValue_15.fields[0];
                if (isEmpty(reminderFees_3)) {
                    warningMessageHtml = react.createElement(react.Fragment, {});
                }
                else if (isEmpty(filter((fee_3) => (fee_3.DeletedAt == null), reminderFees_3))) {
                    warningMessageHtml = react.createElement(react.Fragment, {});
                }
                else {
                    const children_58 = [info(((arg_31 = getTranslation("Billing.ReminderFeesImpose"), toText(printf("%s."))(arg_31))).split(""))];
                    warningMessageHtml = react.createElement("div", {
                        className: "invoices__warning-message",
                        ["data-regression"]: "invoices-reminder-warning",
                    }, ...children_58);
                }
            }
            else {
                warningMessageHtml = react.createElement(react.Fragment, {});
            }
            const invoicesContentHtml = isEmpty(invoicesAndReminderFees) ? ofArray([react.createElement("div", {
                className: "invoices__overview-container",
            }, directInvoiceHtml), (children_63 = [info(getTranslation("CustomerContract.Invoicee.Invoices.NoInvoices").split(""))], react.createElement("div", {
                ["data-translation"]: "CustomerContract.Invoicee.Invoices.NoInvoices",
            }, ...children_63)), renderUpcomingInvoices(new UpcomingInvoicesProps(upcomingInvoicesState[0], props.GlobalDependencies.CountryCode))]) : ofArray([directInvoiceHtml, invoiceeFeesTableHtml, warningMessageHtml, (children_67 = [react.createElement("div", {
                id: "invoices-table",
                className: "invoice-table",
            }, tableHtml), renderUpcomingInvoices(new UpcomingInvoicesProps(upcomingInvoicesState[0], props.GlobalDependencies.CountryCode))], react.createElement("div", {
                className: "invoices__table-container",
            }, ...children_67))]);
            return react.createElement("div", {
                className: "invoices",
                ["data-regression"]: "invoices-container",
            }, ...invoicesContentHtml);
        }
        default: {
            return info(getTranslation("Common.WaitingToLoad").split(""));
        }
    }
}, void 0, uncurry(2, void 0), void 0, "renderInvoices", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Invoices\\View.fs", 1567);

